export function Key(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4101 3.46501C11.4101 3.94826 11.0183 4.34001 10.5351 4.34001C10.0518 4.34001 9.66006 3.94826 9.66006 3.46501C9.66006 2.98176 10.0518 2.59001 10.5351 2.59001C11.0183 2.59001 11.4101 2.98176 11.4101 3.46501ZM9.48499 0C6.95505 0 4.9 2.05505 4.9 4.585C4.9 4.85605 4.93512 5.11726 4.97732 5.35781C4.98979 5.42884 4.967 5.49055 4.92887 5.52868L0.563815 9.89373C0.202811 10.2547 0 10.7444 0 11.2549V12.775C0 13.4515 0.54845 14 1.225 14H2.975C3.65155 14 4.2 13.4515 4.2 12.775V11.9H5.425C5.90827 11.9 6.29999 11.5083 6.29999 11.025V9.8H7.52499C7.99742 9.8 8.38242 9.42564 8.39943 8.95734C8.74712 9.0468 9.11378 9.1 9.48499 9.1C12.0149 9.1 14.07 7.04494 14.07 4.515C14.07 1.9732 12.003 0 9.48499 0ZM5.94999 4.585C5.94999 2.63495 7.53493 1.05 9.48499 1.05C11.447 1.05 13.02 2.5768 13.02 4.515C13.02 6.46506 11.435 8.05 9.48499 8.05C9.00948 8.05 8.51997 7.93023 8.08184 7.74242C7.91958 7.67291 7.73331 7.68957 7.58603 7.78673C7.43868 7.88389 7.34999 8.04853 7.34999 8.225V8.75H6.12499C5.64178 8.75 5.25 9.14172 5.25 9.625V10.85H4.025C3.54175 10.85 3.15 11.2417 3.15 11.725V12.775C3.15 12.8717 3.07165 12.95 2.975 12.95H1.225C1.12835 12.95 1.05 12.8717 1.05 12.775V11.2549C1.05 11.0228 1.14218 10.8003 1.30628 10.6362L5.67132 6.27116C5.9642 5.97828 6.07998 5.5664 6.01152 5.17637C5.97393 4.96219 5.94999 4.76868 5.94999 4.585Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
